export enum SEARCH_VIEW_TYPE {
    Map = 'MAP',
    Ready = 'READY',
    // VipAds = 'SPECIAL-ADS',
    offPlanSale = 'OFF-PLAN-SALE'
}